import { useTranslation } from "react-i18next";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { InfoAccordionRow, InfoRowNested } from "./infoCard";

/** Billing entity selected on the expedition. */
export const BillingEntityAccordion = ({
  expedition,
}: {
  expedition: GetOneExpeditionBoResponseDto;
}) => {
  const { t } = useTranslation(["boExpeditions", "common"]);
  const billingEntityId = expedition.expeditionBillingDetail?.billingEntityId;
  const billingEntity = expedition.company?.billingEntities?.find(
    (be) => be.id === billingEntityId,
  );

  return (
    <InfoAccordionRow
      label={t("expeditionDrawerDetails.billingEntity")}
      value={billingEntity?.companyName}
    >
      {billingEntity && (
        <>
          <InfoRowNested
            label={t("expeditionDrawerDetails.name")}
            value={billingEntity?.companyName}
          />
          <InfoRowNested
            label={t("expeditionDrawerDetails.address")}
            value={billingEntity.street}
          />
          <InfoRowNested
            label={t("expeditionDrawerDetails.city")}
            value={[billingEntity.postalCode, billingEntity.city].filter(Boolean).join(" ")}
          />
          <InfoRowNested
            label={t("expeditionDrawerDetails.country")}
            value={billingEntity.country}
          />
          {billingEntity.numberTVA && (
            <InfoRowNested
              label={t("expeditionDrawerDetails.vat")}
              value={billingEntity.numberTVA}
            />
          )}
          <InfoRowNested label="SIRET" value={billingEntity.companySiret} />
          {billingEntity.companyEori && (
            <InfoRowNested label="EORI" value={billingEntity.companyEori} />
          )}
          <InfoRowNested label={t("expeditionDrawerDetails.email")} value={billingEntity.email} />
        </>
      )}
    </InfoAccordionRow>
  );
};
